import template from './adpCheckbox.html';
import controller from './adpCheckbox.controller';
import './adpCheckbox.less';

let adpCheckboxComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    checkboxId: '@',
    noLabel: '@',
    checked: '='
  },
  template,
  controller
};

export default adpCheckboxComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpCheckbox/adpCheckbox.component.js